<!-- 定位浮动框 -->
<template>
    <modal
        :title="$t('integration.customer_location')"
        :visible="showLocate"
        @close="close"
        width="1000px"
        class="uk-padding-remove"
        append-to-body
    >
        <MapContent :mapObj.sync="mapobj" @locateCallback="locate" v-bind="{ view }"></MapContent>
        <!-- <div id="container" style="width: 100%; height: 480px"></div> -->
    </modal>
</template>

<script>
import { gcj02towgs84 } from '@/utils/postion';
import MapContent from './map/MapContent.vue';
export default {
    props: {
        showLocate: {},
        dioForm: {},
        view: {
            default: false
        }
    },
    components: {
        MapContent
    },
    data() {
        return {
            map: null,
            mapobj: {
                address: this.dioForm.address || $t('integration.runhui_science_park'),
                longitude: this.dioForm.lng || 113.434352,
                latitude: this.dioForm.lat || 23.173331
            }
        };
    },
    methods: {
        close() {
            this.$emit('update:showLocate', false);
        },
        //地图点击定位后返回的信息
        locate(e) {
            const { address, latitude, longitude } = e;
            // gcj02towgs84 内部做数学运算，传入字符串会得到 NaN，需先转 Number
            const [lng, lat] = gcj02towgs84(Number(longitude), Number(latitude));

            const params = {
                address,
                lat,
                lng
            };
            const updated = { ...this.dioForm, ...params };
            this.$emit('update:dioForm', updated);
            // 触发 save 事件，供父组件保存位置到数据库
            this.$emit('save', updated);
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding: 0;
}
::v-deep .el-dialog__footer {
    padding: 0;
}
</style>
